import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/index.css';
import { App } from './App';
import { installInterceptors } from '@core/api/interceptors';
import { installNumberInputGuard } from '@shared/numberInputGuard';

/**
 * Interceptors are installed BEFORE the first render so no component can fire a
 * request that misses the Authorization header or the error-toast layer.
 */
installInterceptors();

/* Number fields are typed, not stepped by the wheel or arrow keys — see `numberInputGuard`. */
installNumberInputGuard();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
